import { BaseController } from '@/api/BaseController';
import { ANY_OBJECT } from '@/types/generic';
import { RequestOption } from '@/common/http/types';
import { API_CONTEXT } from '@/api/config';
import WelcomeSummary from '@/types/table/welcomeSummary';

export default class WelcomeController extends BaseController {
  static summary(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WelcomeSummary>(API_CONTEXT + '/welcome/summary', params, httpOptions);
  }
}
